// /audit — журнал действий. Право — audit.read.content или audit.read.access; какие записи
// видны, решает сервер по ролям и областям (FR-034).
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { AuditPage } from '../../../features/audit/AuditPage.tsx';
import { parseAuditSearch } from '../../../features/audit/search.ts';
import type { AuditSearch } from '../../../features/audit/search.ts';
import { requireSection } from '../../../shell/permissions.ts';

export const Route = createFileRoute('/_app/_settings/audit')({
  validateSearch: parseAuditSearch,
  beforeLoad: requireSection('audit'),
  staticData: { crumb: 'Журнал действий' },
  component: AuditRoute,
});

function AuditRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const onSearchChange = useCallback(
    (next: AuditSearch) => void navigate({ to: '/audit', search: next, replace: true }),
    [navigate],
  );
  return <AuditPage search={search} onSearchChange={onSearchChange} />;
}
